module.exports = __webpack_public_path__ + "img/ja_logo_white.695e3313.svg";